export const meta = {
  title: 'Terms of Service | Firefly Wedding',
  description:
    'Terms for using the unofficial Firefly Wedding fan site, its links and its content.',
  updated_at: '2026-10-14',
};

## Using Firefly Wedding

Firefly Wedding (fireflywedding.org) is an unofficial, non-commercial fan site about the manga and anime _Hotaru no Yomeiri_ (Firefly Wedding). By using the site you agree to these terms.

## Not an official source

We are not affiliated with Shogakukan, Oreco Tachibana, david production, Fuji TV or any streaming service. Schedules, cast, release dates and platform availability are compiled from public reports and may change, so always confirm with the official source linked on each item. The official anime website is [hotaru-anime.com](https://hotaru-anime.com/).

## Intellectual property

_Firefly Wedding_ / _Hotaru no Yomeiri_ and its characters, names and artwork belong to their respective rights holders. Official artwork shown here, such as key visuals, manga covers and character portraits, belongs to its rights holders and is used only to identify the series; other illustrations on this site are original decorative artwork. Short factual information is used for commentary and reference. If you are a rights holder and want something changed, email [support@fireflywedding.org](mailto:support@fireflywedding.org) and we will respond promptly.

## Links to other sites

We link to third-party platforms to help fans find legal ways to watch and read. We do not control those services and are not responsible for their content, pricing or regional availability. We never link to unauthorized copies.

## Accounts

If you create an account, keep your credentials safe and do not use the site to harass others, spam or break the law. We may suspend accounts that do.

## Disclaimer

The site is provided "as is" without warranties. To the extent permitted by law we are not liable for losses arising from its use.

## Changes

We may update these terms; continued use after an update means you accept the new version.
